import { theme } from 'styled-tools'
import styled from 'styled-components/macro'
import { media } from '../../../ui/rwd'
import posed from 'react-pose'

const Line = styled.div`
  width: 100%;
  height: 2px;
  background: ${theme('categoryLine')};
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 1;
`

const AnimatedContainer = posed.div({
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 150,
      damping: 15,
      delay: 150
    }
  },

  hidden: {
    opacity: 0,
    y: 100
  }
})

const TagContainer = styled(AnimatedContainer)`
  display: flex;
  position: relative;
  justify-content: center;
  margin-bottom: 8px;
`

const TagTextBox = styled.span`
  border-radius: 12px;
  background: ${theme('categoryBox')};
  padding: 0.6rem 1rem;
  color: ${theme('categoryText')};
  z-index: 2;
  box-shadow: 2px 2px 9px 0px rgba(0, 0, 0, 0.3);
  ${media.sm.down`
      font-size: 1rem;
    `}
`

export { TagTextBox, TagContainer, Line }
